<template>
  <rest-list-action :icon="icon" :title="title" :click="click" />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'
import { projectRoute } from '@/core/helpers'
export default {
  name: 'RestListActionTask',

  components: { RestListAction },

  props: {
    icon: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: false
    },

    endpoint: {
      type: Object,
      required: true
    }
  },
  methods: {
    click() {
      RestApi(this.endpoint)
        .then(({ data }) => {
          let redirectRoute = projectRoute({
            name: 'TaskHistoryView',
            query: { id: data }
          })
          this.$router.push(redirectRoute)
        })
        .catch(error => {
          if (error.response.status === 500) {
            this.$message({
              message: `${this.$t('Error_500Message')}`,
              type: 'error'
            })
          } else {
            this.$message({
              message: error.response.data.message,
              type: 'error'
            })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionTask.vue